// src/store.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from "./slices/auth";
import messageReducer from "./slices/message";
import providerApplicationReducer, { PROVIDER_APPLICATION_CACHE_KEY } from './slices/providerApplication';

const store = configureStore({
  reducer: {
    auth: authReducer,
    message: messageReducer,
    providerApplication: providerApplicationReducer
  },
});

store.subscribe(() => {
  try {
    window.sessionStorage.setItem(
      PROVIDER_APPLICATION_CACHE_KEY,
      JSON.stringify(store.getState().providerApplication),
    );
  } catch {
    // The workflow remains usable if browser storage is unavailable.
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;




